var voted_users_default = {
  "container": "Yy9oW",
  "webview": "iHV-h",
  "avatar_list": "q-cS3",
  "avatar": "L4bkS",
  "user_avatar": "dfmOv",
  "modal": "_-0YX5",
  "voted_users_modal": "_59SVX",
  "overlay": "_4FW3b",
  "user_card": "HyAC-",
  "user_name": "qF9Tp",
  "voted_users_modal_header": "a55ye",
  "cta": "_36CZs",
  "close_icon": "euMM9",
  "title": "_8EphV",
  "member_list_container": "EjucG",
  "member_list": "_9AHq4",
  "loader": "EKzgi",
  "anonymous_counter": "JhH9b",
  "spinner": "rvBOU",
  "spin": "ykU2y"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
